import { render, staticRenderFns } from "./adminJournal.vue?vue&type=template&id=a6a6454e&scoped=true&"
import script from "./adminJournal.vue?vue&type=script&lang=js&"
export * from "./adminJournal.vue?vue&type=script&lang=js&"
import style0 from "./adminJournal.vue?vue&type=style&index=0&id=a6a6454e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a6454e",
  null
  
)

export default component.exports